import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot} from '@angular/router';
import { Observable } from 'rxjs';

import { Tranche } from 'src/app/model/tranche.model';
import { TrancheService } from 'src/app/shared/services/tranche.service';

@Injectable({ providedIn: 'root'})
export class TrancheResolver implements Resolve<Observable<Tranche[]>> {

    constructor(
         private trancheService: TrancheService
    ) {}

    resolve(route: ActivatedRouteSnapshot
        ): Observable<Tranche[]>  {
        return this.trancheService.getTranches();
    }
}
